import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import Filter from '../../../components/Filter/Filter';
import { FirstFilterLine, SecondFilterLine } from '../../../components/Filter/Filter.styles';
import TextField from '../../../components/TextField';
import DateInput from '../../../components/DateInput';
import SelectOptions from '../../../components/SelectOptions';
import Modal from '../../../components/Modal/Modal';
import { translateMessage } from '../../../utils/functions/translateMessage';
import Button from '../../../components/Button/Button';
import { ImSearch } from 'react-icons/im';
import { LoadingContainer } from '../../GerenciarClientes/styles/GerenciarClientes.styles';
import { CircularProgress } from '@material-ui/core';
import Table from '../../../components/Table/Table';
import formatCPF from '../../../utils/functions/formatCPF';
import formatCNPJ from '../../../utils/functions/formatCNPJ';
import formatMoney from '../../../utils/functions/formatMoneyBRL';
import useCallFilter from '../../../utils/hooks/useCallFilter';
import {
  pixTransactionsFetchAction,
  pixTransactionDebitDetailsFetchAction,
  pixTransactionCreditDetailsFetchAction,
  pixTransactionAproveFetchAction,
  pixRefetchFailedAction,
} from '../../../store/fetchActions/pixTransactionsActions';
import { antiFraudInfoUrlFetchAction } from '../../../store/fetchActions/pixAntiFraudActions';
import { ConvertObjectToArrayCreditDetails } from './ConvertObjectsToArray';
import StatusContainer from '../../../components/StatusContainer/StatusContainer';
import { useTheme } from 'styled-components';
import moment from 'moment';
import InformationPix from '../components/InformationPix';
import { Box, Checkbox, Tooltip } from '@mui/material';
import * as Styled from '../../PerfisUsuarios/PerfisUsuarios.styles';
import { HiEye, HiOutlineEye, HiOutlineReceiptTax, HiOutlineViewGrid, HiOutlineViewList } from 'react-icons/hi';
import ModalTwoFactor from '../../../components/TwoFactor/ModalTwoFactor';
import CheckBoxHook from './useCheckBoxPixTransaction';
import useCheckBoxPixTransaction from './useCheckBoxPixTransaction';
import NameAndDocumentIdGrid from '../../AdminPix/components/NameAndDocumentIdGrid';
import { padding } from 'polished';
import { startOfMonth } from 'date-fns';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { IconButton } from '@mui/material';
import { set } from 'lodash';
import IconAutoAprovePix from '../../../assets/icon/ApprovedPixAuto';
import { boolean } from 'yup';
import IconAntifraudeAnalise from '../../../assets/icon/IconAntifraudeAnalise';
import IconAntifraudeAprovada from '../../../assets/icon/IconAntifraudeAprovada';
import IconAntifraudeReprovada from '../../../assets/icon/IconAntifraudeReprovada';
import IconAntifraudeSemAnalise from '../../../assets/icon/IconAntifraudeSemAnalise';
import IconAntifraudeFalhaAnalise from '../../../assets/icon/IconAntifraudeFalhaAnalise';

const Extracts = () => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [isModalInfoOpen, setIsModalInfoOpen] = useState(false);
  const [idTypeTransaction, setIdTypeTransaction] = useState(null);
  const [idTransaction, setIdTransaction] = useState(null);

  const [dateInicial, setDateInicial] = useState(null);
  const [dateFinal, setDateFinal] = useState(moment().format('YYYY-MM-DD'));

  const [filterData, setFilterData] = useState({
    SEARCH: '',
    LIMIT: 10,
    PAGE: 1,
    TIPO_TRANSACAO: '',
    DATA_INICIAL: dateInicial,
    DATA_FINAL: dateFinal,
    STATUS_TRANSACAO: '',
    PAGTO: '',
    ORDENACAO: 'DESC',
  });


  const [totalSelected, setTotalSelected] = useState({
    totalTransactions: 0,
    totalValue: 0,
  });

  const [showModalTwoFactor, setShowModalTwoFactor] = useState(false);
  const { handleSubmit, control } = useForm({});
  const { control: tokenControl } = useForm({});

  const {
    dataPixTransactions,
    loadingPixTransactions,
    errorLoadingPixTransactions,
    paginationPixTransactions,
    errorMessagePixTransactions,
    detailsPixTransaction,
    loadingDetailsPixTransaction,
    successDetailsPixTransaction,
    messageDetailsPixTransaction,
  } = useSelector((state) => state.pixTransactions);

  const { antiFraudInfoUrl } = useSelector((state) => state.pixAntiFraud);

  useEffect(() => {
    dispatch(antiFraudInfoUrlFetchAction());
  }, []);

  const { transactionSelected, setTransactionSelected, handleChangeSelectAll, verifyIfAllTransactionsAreSelected } =
    useCheckBoxPixTransaction(dataPixTransactions, setTotalSelected);

  const filterTable = (data) => {
    //console.log('data', data)
    data.DATA_INICIAL = dateInicial;
    data.DATA_FINAL = dateFinal;
    setFilterData(data);
  };

  const closeModalInfo = () => {
    setIsModalInfoOpen(false);
  };

  useEffect(() => {
    dispatch(pixTransactionsFetchAction(filterData));
  }, [filterData.PAGE, filterData.ORDENACAO, filterData]);

  const arrayTransactionTypes = [
    { ID: 0, NOME: 'Todos' },
    { ID: 1, NOME: 'Pagamento' },
    { ID: 2, NOME: 'Recebimento' },
  ];

  const arrayStatus = [
    { ID: 0, NOME: 'Todos' },
    { ID: 1, NOME: 'Aguardando' },
    { ID: 2, NOME: 'Aprovado' },
    { ID: 3, NOME: 'Cancelado' },
    { ID: 5, NOME: 'Processando' },
  ];

  const pageOptions = [
    { ID: 10, NOME: 10 },
    { ID: 25, NOME: 25 },
    { ID: 50, NOME: 50 },
    { ID: 100, NOME: 100 },
    { ID: 250, NOME: 250 },
    { ID: 500, NOME: 500 },
  ];

  const pagtoOptions = [
    { ID: 'DATA', NOME: 'Criação' },
    { ID: 'DATA_PAGTO', NOME: 'Pagamento' },
  ];

  const detailsArray = ConvertObjectToArrayCreditDetails(detailsPixTransaction, idTypeTransaction);

  const header = [
    {
      id: 'id',
      name: '',
      align: 'center',
    },
    {
      id: 'data de registro',
      name: 'DATA',
      align: 'center',
    },
    {
      id: 'payer',
      name: 'PAGADOR',
      align: 'left',
    },
    {
      id: 'receiver',
      name: 'RECEBEDOR',
      align: 'left',
    },
    {
      id: 'tipo transação',
      name: 'TIPO TRANSAÇÂO',
      align: 'center',
    },
    {
      id: 'status',
      name: 'STATUS TRANSAÇÂO',
      align: 'center',
    },
    {
      id: 'valor',
      name: 'VALOR',
      align: 'right',
    },
    {
      id: 'pagamento',
      name: (
        <Box display="flex" flexWrap={'nowrap'} alignItems="center">
          <span alignItems={'center'}>PAGTO</span>
          <Box display="flex" mt={0.5} flexDirection={'column'}>
            <IconButton
              size="small"
              onClick={() => {
                setFilterData((prev) => ({ ...prev, ORDENACAO: 'ASC' }));
              }}
            >
              <ArrowUpwardIcon fontSize="inherit" />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => {
                setFilterData((prev) => ({ ...prev, ORDENACAO: 'DESC' }));
              }}
            >
              <ArrowDownwardIcon fontSize="inherit" />
            </IconButton>
          </Box>
        </Box>
      ),
      align: 'center',
    },
    {
      id: 'ações',
      name: 'AÇÕES',
      align: 'center',
    },
  ];

  const verifyIfAllowRefund = () => {
    return (
      (detailsPixTransaction?.ID_DEVOLUCAO == undefined ||
        detailsPixTransaction?.ID_DEVOLUCAO == '' ||
        detailsPixTransaction?.ID_DEVOLUCAO == null) &&
      idTypeTransaction == 1 &&
      detailsPixTransaction.IDSTATUS == 2
    );
  };

  const handleSelectTransaction = (idTransaction) => {
    setTransactionSelected((prev) =>
      prev.includes(idTransaction) ? prev.filter((id) => id !== idTransaction) : [...prev, idTransaction],
    );
  };

  const verifyIfTransactionIsDisabled = (transaction) => {
    return transaction.STATUS !== 'AGUARDANDO' || transaction.TIPO_TRANSACAO_PIX != 'PAGAMENTO' || transaction?.AUTO_APROVE_PIX || transaction?.WAS_APPROVE || transaction?.ACTION === 'REJECTED';
  }

  const [retrying, setRetrying] = useState(false);
  const retryTransaction = (transaction) => {
    setRetrying(true);
    dispatch(
      pixRefetchFailedAction(
        {
          ID_TRANSACAO: transaction.ID,
        },
      ),
    ).finally(() => setRetrying(false));
  };

  const renderAntifraudeIcon = (transaction) => {
    switch (transaction?.ACTION) {
      case 'REVIEW':
        return (
          <Tooltip title="Em análise">
            <Styled.IconV2Container
              backgroundcolor={'#FFA8061A'}
              onClick={() => antiFraudInfoUrl && window.open(antiFraudInfoUrl, '_blank')}>
              <IconAntifraudeAnalise />
            </Styled.IconV2Container>
          </Tooltip>
        );
      case 'APPROVED':
        return (
          <Tooltip title="Aprovada">
              <Styled.IconV2Container backgroundcolor={'#00BA821A'} cursor>
                <IconAntifraudeAprovada />
              </Styled.IconV2Container>
            </Tooltip>
        )
      case 'REJECTED':
        return (
          <Tooltip title="Reprovada">
            <Styled.IconV2Container backgroundcolor={'#FF4C511A'} cursor>
              <IconAntifraudeReprovada />
            </Styled.IconV2Container>
          </Tooltip>
        );
      case 'FAILED':
        return (
          <Tooltip title="Falha na análise">
            <Styled.IconV2Container
              onClick={!retrying ? () => retryTransaction(transaction) : undefined}
              backgroundcolor={'#FF4C511A'}
              style={{ pointerEvents: retrying ? 'none' : 'auto', opacity: retrying ? 0.6 : 1 }}
            >
              <IconAntifraudeFalhaAnalise />
            </Styled.IconV2Container>
          </Tooltip>
        );
      default:
        return (
          <Tooltip title="Sem análise">
            <Styled.IconV2Container backgroundcolor={'#BCBCBC33'} cursor>
              <IconAntifraudeSemAnalise />
            </Styled.IconV2Container>
          </Tooltip>
        );
    }
  }

  const body = dataPixTransactions?.map((transaction) => {
    const colorIconAutoAprove = transaction?.AUTO_APROVE_PIX ? '#116BAD' : '#CCCC';
    return {
      data: [
        {
          info: (
            <Checkbox
              onChange={(event) => {
                event.stopPropagation();
                setTotalSelected((prev) => ({
                  ...prev,
                  totalTransactions: prev.totalTransactions + (event.target.checked ? 1 : -1),
                  totalValue:
                    prev.totalValue +
                    (event.target.checked ? parseFloat(transaction.VALOR) : parseFloat(transaction.VALOR) * -1),
                }));
                handleSelectTransaction(transaction.ID);
              }}
              checked={transactionSelected.includes(transaction.ID)}
              disabled={verifyIfTransactionIsDisabled(transaction)}
            />
          ),
          align: 'center',
          isCheckBox: true,
        },
        { info: transaction.DATA_TRANSACAO, align: 'center' },
        {
          info: <NameAndDocumentIdGrid name={transaction?.NOME_PAGADOR} documentId={transaction?.CPFCNPJ_PAGADOR} />,
          align: 'left',
        },
        {
          info: (
            <NameAndDocumentIdGrid name={transaction?.NOME_RECEBEDOR} documentId={transaction?.CPFCNPJ_RECEBEDOR} />
          ),
          align: 'left',
        },
        { info: transaction.TIPO_TRANSACAO_PIX, align: 'center' },
        {
          info: transaction?.IDSTATUS ? (
            <StatusContainer
              code={transaction?.IDSTATUS}
              description={transaction?.STATUS === 'Confirmado' ? 'Aprovado' : transaction.STATUS}
            ></StatusContainer>
          ) : (
            '-----'
          ),
          align: 'center',
        },
        { info: 'R$ ' + formatMoney(transaction.VALOR), align: 'right' },
        { info: transaction.DATA_PAGTO, align: 'center' },
        {
          info: (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '6px' }}>
              {
                renderAntifraudeIcon(transaction)
              }
              <Tooltip title="Aprovado automaticamente">
              <Styled.IconV2Container
                  backgroundcolor={'#116BAD1A'}
                >
                  <IconAutoAprovePix color={colorIconAutoAprove} />
                  </Styled.IconV2Container>
              </Tooltip>
              <Tooltip title="Visualizar transferência">
                <Styled.IconV2Container
                  onClick={() => {
                    inspectTransaction(transaction);
                  }}
                  backgroundcolor={theme.colors.grayTransparent}
                >
                  <HiOutlineEye size={25} />
                </Styled.IconV2Container>
              </Tooltip>
            </Box>
          ),
          align: 'center',
          width: '200px',
        },
      ],
    };
  });

  const totalValue = dataPixTransactions.reduce((acc, value) => {
    return (acc += parseFloat(value.VALOR));
  }, 0);

  const totalTransactions = dataPixTransactions.length;

  const footer = {
    totalValue: {
      label: 'Valor total: ',
      info: `R$ ${formatMoney(totalValue)}`,
      align: 'right',
    },
    totalTransactions: {
      label: 'Total de transações: ',
      info: `${totalTransactions}`,
      align: 'right',
    },
    totalTransactionsSelected: {
      label: 'Total de transações selecionado: ',
      info: `${totalSelected.totalTransactions}`,
      align: 'right',
    },
    totalValueSelected: {
      label: 'Valor total selecionado: ',
      info: `R$ ${formatMoney(totalSelected.totalValue)}`,
      align: 'right',
    },
  };

  const aproveTransactionBatch = () => {
    setShowModalTwoFactor(true);
  };
  const aproveTransaction = (data) => {
    dispatch(
      pixTransactionAproveFetchAction(
        {
          ID_TRANSACAO: transactionSelected,
          TOKEN: data,
        },
        updateDataGrid,
      ),
    );
  };

  const resetTransactionSelected = () => {
    setTransactionSelected([]);
    setShowModalTwoFactor(false);
  };

  const handleCloseAndResetTransactionSelected = () => {
    resetTransactionSelected();
  };

  const handleCloseModalTwoFactor = () => {
    setIsModalInfoOpen(false);
    updateDataGrid();
  };

  const updateDataGrid = () => {
    dispatch(pixTransactionsFetchAction(filterData));
  };

  function inspectTransaction(transaction) {
    if (transaction?.TIPO_TRANSACAO_PIX === 'RECEBIMENTO') return;

    const { IDTIPOTRANSACAO, ID } = transaction;
    setIdTypeTransaction(IDTIPOTRANSACAO);
    setIdTransaction(ID);

    if (IDTIPOTRANSACAO == 1) dispatch(pixTransactionDebitDetailsFetchAction({ ID_TRANSACAO: ID }));
    if (IDTIPOTRANSACAO == 2) dispatch(pixTransactionCreditDetailsFetchAction({ ID_TRANSACAO: ID }));

    setIsModalInfoOpen(true);
  }

  return (
    <>
      <div>
        <Filter>
          <form onSubmit={handleSubmit(filterTable)}>
            <FirstFilterLine>
              <TextField label="Nome, CPF/CNPJ ou Valor" name={'SEARCH'} width={'23vw'} control={control} />
              <SelectOptions
                control={control}
                options={arrayTransactionTypes}
                name={'TIPO_TRANSACAO'}
                width={'9vw'}
                label={'Tipo Transação'}
                initialValue={0}
              />
              <SelectOptions
                label={'Status Transação'}
                width={'9vw'}
                name={'STATUS_TRANSACAO'}
                control={control}
                options={arrayStatus}
                initialValue={'0'}
              />
              <SelectOptions
                control={control}
                options={pagtoOptions}
                name={'TIPO_DATA'}
                width={'12vw'}
                label={'Tipo Filtro Data'}
                initialValue={'DATA'}
              />
              <DateInput
                label="Data Inicial"
                name={'DATA_INICIAL'}
                control={control}
                value={dateInicial}
                width={'9vw'}
                onChange={(newValue) =>
                  newValue?.$d ? setDateInicial(moment(newValue?.$d).format('YYYY-MM-DD')) : setDateInicial(null)
                }
              />
              <DateInput
                label="Data Final"
                name={'DATA_FINAL'}
                control={control}
                value={dateFinal}
                width={'9vw'}
                onChange={(newValue) =>
                  newValue?.$d ? setDateFinal(moment(newValue?.$d).format('YYYY-MM-DD')) : setDateFinal(null)
                }
              />
              <Button
                backgroundcolor={theme.colors.buttonSearch}
                width={'16vw'}
                hoverbgcolor={theme.colors.buttonSearchHover}
                hovercolor={theme.colors.buttonSearchHoverText}
                mycolor={theme.colors.buttonSearchText}
                type="submit"
              >
                <ImSearch className="default-svg" size={'1.181vw'} />
                <span>Buscar</span>
              </Button>
            </FirstFilterLine>
            <SecondFilterLine>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <Box>
                  <Checkbox
                    onChange={(event) => handleChangeSelectAll(event)}
                    checked={verifyIfAllTransactionsAreSelected()}
                    indeterminate={
                      dataPixTransactions?.some(
                        (transaction) =>
                          transaction.STATUS === 'AGUARDANDO' && transactionSelected.includes(transaction.ID),
                      ) &&
                      !dataPixTransactions?.every(
                        (transaction) =>
                          transaction.STATUS !== 'AGUARDANDO' || transactionSelected.includes(transaction.ID),
                      )
                    }
                  />
                  <span>Selecionar todos</span>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {transactionSelected.length > 0 && (
                    <Button onClick={() => aproveTransactionBatch()}>Aprovar pagamento</Button>
                  )}

                  <h5>Resultados por Página</h5>
                  <SelectOptions control={control} options={pageOptions} name={'LIMIT'} initialValue={10} />
                </Box>
              </Box>
            </SecondFilterLine>
          </form>
        </Filter>
        {loadingPixTransactions ? (
          <LoadingContainer>
            <CircularProgress size={'5vw'} color="inherit" />
          </LoadingContainer>
        ) : (
          <Table
            loading={loadingPixTransactions}
            error={errorLoadingPixTransactions}
            hasPagination={true}
            filter={filterData}
            pagination={paginationPixTransactions}
            setFilter={filterTable}
            errorMessage={errorMessagePixTransactions}
            filterTable={filterTable}
            body={body}
            header={header}
            limit={filterData.LIMIT}
            hasFooter={true}
            footer={footer}
          />
        )}
        <Modal open={isModalInfoOpen} close={closeModalInfo} title="Dados da Transação PIX" width={'47.889vw'}>
          {loadingDetailsPixTransaction ? (
            <LoadingContainer marginTop={'1vw'}>
              <CircularProgress size={'5vw'} color="inherit" />
            </LoadingContainer>
          ) : !successDetailsPixTransaction ? (
            <h1>{translateMessage(messageDetailsPixTransaction)}</h1>
          ) : (
            <InformationPix
              data={detailsArray}
              idTransaction={idTransaction}
              allowRefund={verifyIfAllowRefund()}
              isAproved={detailsPixTransaction.IDSTATUS == 2}
              showButton={detailsPixTransaction.IDSTATUS === 1 ? true : false}
              refund={detailsPixTransaction?.PIX_REEMBOLSO === 'S'}
              onClose={handleCloseModalTwoFactor}
            />
          )}
        </Modal>
        {showModalTwoFactor && (
          <ModalTwoFactor
            open={showModalTwoFactor}
            onClose={handleCloseAndResetTransactionSelected}
            handleToken={aproveTransaction}
            onSubmit={(data) => aproveTransaction(data)}
            control={tokenControl}
          />
        )}
      </div>
    </>
  );
};

export default Extracts;
